/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TrackingMelcoModelsBoolResponse,
    TrackingMelcoModelsBoolResponseFromJSON,
    TrackingMelcoModelsBoolResponseToJSON,
    TrackingMelcoModelsError,
    TrackingMelcoModelsErrorFromJSON,
    TrackingMelcoModelsErrorToJSON,
    TrackingMelcoModelsGenericList1MelcoModelsLogListItem,
    TrackingMelcoModelsGenericList1MelcoModelsLogListItemFromJSON,
    TrackingMelcoModelsGenericList1MelcoModelsLogListItemToJSON,
    TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry,
    TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryFromJSON,
    TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryToJSON,
    TrackingMelcoModelsLogData,
    TrackingMelcoModelsLogDataFromJSON,
    TrackingMelcoModelsLogDataToJSON,
    TrackingMelcoModelsLogUpload,
    TrackingMelcoModelsLogUploadFromJSON,
    TrackingMelcoModelsLogUploadToJSON,
} from '../models';

export interface DiagnosticsApiDiagnosticsGetLogsByIdRequest {
    id: string;
}

export interface DiagnosticsApiDiagnosticsLogFilesDownloadRequest {
    id: string;
}

export interface DiagnosticsApiDiagnosticsLogFilesGetListRequest {
    searchText?: string;
    offset?: number;
    limit?: number;
    sortBy?: string;
    productList?: string;
}

export interface DiagnosticsApiDiagnosticsLogFilesUploadRequest {
    trackingMelcoModelsLogUpload?: TrackingMelcoModelsLogUpload;
}

export interface DiagnosticsApiDiagnosticsUploadLogsRequest {
    deviceName?: string;
    file?: Blob;
}

/**
 * 
 */
export class DiagnosticsApi extends runtime.BaseAPI {

    /**
     */
    async diagnosticsGetLogsByIdRaw(requestParameters: DiagnosticsApiDiagnosticsGetLogsByIdRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling diagnosticsGetLogsById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diagnostics/logs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryFromJSON(jsonValue));
    }

    /**
     */
    async diagnosticsGetLogsById(requestParameters: DiagnosticsApiDiagnosticsGetLogsByIdRequest): Promise<TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry> {
        const response = await this.diagnosticsGetLogsByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async diagnosticsLogFilesDownloadRaw(requestParameters: DiagnosticsApiDiagnosticsLogFilesDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling diagnosticsLogFilesDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diagnostics/toolbox/log_files/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async diagnosticsLogFilesDownload(requestParameters: DiagnosticsApiDiagnosticsLogFilesDownloadRequest): Promise<Blob> {
        const response = await this.diagnosticsLogFilesDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async diagnosticsLogFilesGetListRaw(requestParameters: DiagnosticsApiDiagnosticsLogFilesGetListRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1MelcoModelsLogListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/diagnostics/toolbox/log_files`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1MelcoModelsLogListItemFromJSON(jsonValue));
    }

    /**
     */
    async diagnosticsLogFilesGetList(requestParameters: DiagnosticsApiDiagnosticsLogFilesGetListRequest): Promise<TrackingMelcoModelsGenericList1MelcoModelsLogListItem> {
        const response = await this.diagnosticsLogFilesGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async diagnosticsLogFilesUploadRaw(requestParameters: DiagnosticsApiDiagnosticsLogFilesUploadRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsLogData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/diagnostics/toolbox/log_files`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrackingMelcoModelsLogUploadToJSON(requestParameters.trackingMelcoModelsLogUpload),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsLogDataFromJSON(jsonValue));
    }

    /**
     */
    async diagnosticsLogFilesUpload(requestParameters: DiagnosticsApiDiagnosticsLogFilesUploadRequest): Promise<TrackingMelcoModelsLogData> {
        const response = await this.diagnosticsLogFilesUploadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async diagnosticsUploadLogsRaw(requestParameters: DiagnosticsApiDiagnosticsUploadLogsRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.deviceName !== undefined) {
            queryParameters['device_name'] = requestParameters.deviceName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/diagnostics/logs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async diagnosticsUploadLogs(requestParameters: DiagnosticsApiDiagnosticsUploadLogsRequest): Promise<TrackingMelcoModelsBoolResponse> {
        const response = await this.diagnosticsUploadLogsRaw(requestParameters);
        return await response.value();
    }

}
